import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";

import Media from "../../common/media";

import FormHeader from "../../common/form/formHeader";
import FormFooter from "../../common/form/formFooter";

import { uploadFiles, deleteFile } from "../../../services/fileService";
import { getEntity, saveEntity } from "../../../services/apiService";

class TagFrom extends Media {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFileSelect = this.handleFileSelect.bind(this);

    this.state = {
      data: {
        title_en: "",
        title_de: "",
        description_en: "",
        description_de: "",
        caption_en: "",
        caption_de: "",
        filename: "",
        image_aspect_ratio: "",
      },
      images: [],
      previewImages: [],
      selectedImages: [],
      labels: [],
      progresses: [],
      currentFiles: { filename: "" },
      selectedFiles: { filename: "" },
      inputLabels: { filename: "" },
      types: { filename: "" },
      errors: {},
    };
  }

  // Define the Form Schema
  schema = {
    _id: Joi.string(),
    title_en: Joi.string().min(2).max(50).required().label("Title"),
    title_de: Joi.string().min(2).max(50).required().label("Titel"),
    description_en: Joi.string()
      .min(10)
      .max(1000)
      .required()
      .label("Description"),
    description_de: Joi.string()
      .min(10)
      .max(1000)
      .required()
      .label("Beschreibung"),
    caption_en: Joi.string().min(5).max(500).required().label("Caption"),
    caption_de: Joi.string()
      .min(5)
      .max(500)
      .required()
      .label("Bildunterschrift"),

    filename: Joi.string().label("Image").required(),
    image_aspect_ratio: Joi.number()
      .min(0.1)
      .max(4)
      .label("Aspect Ratio")
      .required(),
  };

  // Retrive the Data from the Server
  async componentDidMount() {
    // Get the Given ID
    const tag_id = this.props.match.params.id;
    if (tag_id === "new") return;

    // Get Tag related to the Given ID
    const { data: tag } = await getEntity("tag", tag_id);
    if (!tag) return this.props.history.replace("/not-found");

    this.setState({
      data: this.mapToViewModel(tag),
      currentFiles: { filename: tag.filename },
    });
  }

  // Map current Tag to the Form Inputs
  mapToViewModel(tag) {
    return {
      _id: tag._id,
      title_en: tag.title_en,
      title_de: tag.title_de,
      description_en: tag.description_en,
      description_de: tag.description_de,
      caption_en: tag.caption_en,
      caption_de: tag.caption_de,
      filename: tag.filename,
      image_aspect_ratio: tag.image_aspect_ratio,
    };
  }

  // Form submit Function
  doSubmit = async () => {
    // Data for saving to the Database
    const { data, selectedImages, currentFiles } = this.state;

    try {
      // Saving Tag
      const response = await saveEntity("tag", data);
      if (response.data && response.status !== 200) return;

      // Uploading File
      if (selectedImages.length) {
        const header = `tags/${response.data._id}`;
        const progressInfos = [...this.state.progresses];

        await uploadFiles(selectedImages[0], header, (event) => {
          progressInfos[0].percentage = Math.round(
            (100 * event.loaded) / event.total
          );

          this.setState({ progresses: progressInfos });
        })
          .then(() => {
            // Success Message of File uploading
            toast.success(
              `File: ${progressInfos[0].fileName} \n uploaded sucessfully!`
            );
          })
          .catch(() => {
            progressInfos[0].percentage = 0;

            this.setState({ progresses: progressInfos });

            // Error Message of File uploading
            toast.error(
              `File: ${progressInfos[0].fileName} \n can not be uploaded.`
            );
          });
      }

      // Success Message of Tag Saving
      toast.success(
        <div>
          Tag: "{response.data.title_en}" <br /> saved successfully.
        </div>
      );

      // Delete Previous File if exists.
      if (currentFiles.filename && data.filename !== currentFiles.filename)
        await deleteFile("tags", currentFiles.filename);
    } catch (ex) {
      toast.error(ex.response?.message ?? ex.response.data?.message);

      return;
    }

    // Return to Tags TableView after saving
    this.handleBack();
  };

  // Back button Event Handler
  handleBack = () => {
    // Table Pagination Query
    const searchParams = new URLSearchParams(window.location.search);
    const currentPageQuery = searchParams.get("currentPage");
    const pageSizeQuery = searchParams.get("pageSize");

    // Return to Tags TableView after saving
    if (currentPageQuery && pageSizeQuery) {
      this.props.history.push(
        `/dashboard/tags?pageSize=${pageSizeQuery}&currentPage=${currentPageQuery}`
      );
    } else {
      this.props.history.push("/dashboard/tags");
    }
  };

  render() {
    const id = this.props.match.params.id;
    const { progresses, errors } = this.state;

    return (
      <div className="col alt-table-responsive">
        <FormHeader name="Tag" icon="bx bxs-purchase-tag-alt" id={id} />
        <form
          onSubmit={this.handleSubmit}
          className="form-group"
          encType="multipart/form-data"
        >
          <div className="row pt-2 mt-2">
            <div className=" col-sm-6">
              <div className="row mt-1">
                <div className="col">
                  {this.renderInput("title_en", "Title")}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  {this.renderTextBox("description_en", "Description")}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  {this.renderTextBox("caption_en", "Caption")}
                </div>
              </div>

              <hr />

              <div className="row mt-4">
                <div className="col">
                  {this.renderInput("title_de", "Titel")}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  {this.renderTextBox("description_de", "Beschreibung")}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  {this.renderTextBox("caption_de", "Bildunterschrift")}
                </div>
              </div>
            </div>

            <div className=" col-sm-6 border-left">
              <div className="row">
                <div className="col">
                  {this.renderMediaUploader(
                    "Image",
                    "filename",
                    "tags",
                    "_id",
                    "image/*",
                    "image_aspect_ratio"
                  )}{" "}
                </div>
              </div>
              <div className="row">
                <div className="col"> {this.renderErrors(errors)}</div>
              </div>
              <div className="row">
                <div className="col">{this.renderUploadStatus(progresses)}</div>
              </div>
            </div>
          </div>
          <FormFooter
            onBackClick={this.handleBack}
            onValidate={this.validate()}
          />
        </form>
      </div>
    );
  }
}

export default TagFrom;
